<template>
  <div class="l-container">
    <div class="noti-container">
      <div class="noti-container_inner">
        <div class="noti-container_inner-thumbnail">
          <div class="noti-container_inner-thumbnail-border" />
          <div class="noti-container_inner-thumbnail-title">
            <h1>こども料金の目安について</h1>
          </div>
          <div class="noti-container_inner-thumbnail-content">
            <ul>
              <li>
                子ども料金の区分について <br />
                <span
                  >子ども料金は、原則として小学生以下のお子様を対象として設定されています(中学生以上は大人料金
                  となります)。小学生未満のお子様については、年齢に関係なく食事・布団の有無で料金が設定されています。
                </span>
              </li>
              <li>
                子どもの食事有無について <br />
                <span
                  >「小学生」「幼児：布団・食事あり」「幼児:食事あり」の区分をご利用の場合も、食事の有無は大人
                  に準じます。大人の食事がつかないプランではお食事は付きませんので、ご了承ください。(例)大人
                  が「朝食なし」のプランを選択した場合は、子ども区分で「食事あり」の予約をしても、お子様には食事
                  は付きません。</span
                >
              </li>
              <li>
                子どもの食事/布団の内容について <br />
                <span
                  >子ども料金で宿泊される子どものお食事/布団の内容は、大人に準じたもの、お子様用に変更したものなど
                  がありますが、各宿泊施設によって異なります。</span
                >
              </li>
              <li>
                部屋の定員について <br />
                <span>
                  部屋には「布団を敷ける数」としての「定員」があり、布団を必要とされるお子様については料金が大
                  人と同額かどうかに関わらず、定員上は
                  1名として数えます。1室に定員を超える人数での宿泊はでき ません。</span
                >
              </li>
              <li>
                大人1名のご予約について <br />
                <span>
                  原則、1室に大人の方が1名でご利用の場合は、小学生以下のお子様も大人料金となります。</span
                >
              </li>
            </ul>
          </div>
          <div class="noti-container_inner-thumbnail-border" />
        </div>
        <div class="noti-container_inner-close">
          <button @click="handleBack()">
            <span> 戻る</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BREADCRUMBS } from '@/store/modules/app/actions'
export default {
  name: 'Children-Notification',
  mounted() {
    this.$store.dispatch(BREADCRUMBS, [])
  },
  methods: {
    handleBack() {
      //リファラーがundefinedの場合があるため、分岐を用意
      if (this.$router.referrer) {
        this.$router.go(-1)
      } else {
        window.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
